import { Box, Tooltip, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import StatusCell from "./StatusCell";

const handleActions = (params, handleEdit) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        height: "100%",
        minHeight: "52px",
      }}
    >
      {/* Edit Button - Always visible with icon and text */}

      {
        params.row.allow_edit === 1 && (

        
      <Box
        display="flex"
        alignItems="center"
        sx={{
          backgroundColor: "#FAFAFA",
          borderRadius: "6px",
          border: "1px solid #E0E0E0",
          padding: "4px 0",
          gap: 1,
        }}
      >
        <Tooltip title="Edit">
          <Box
            display="flex"
            alignItems="center"
            sx={{
              cursor: "pointer",
              padding: "4px 8px",
              borderRadius: "4px",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
            onClick={() => handleEdit(params.row)}
          >
            <EditIcon fontSize="small" color="primary" />
            <Typography
              variant="body2"
              sx={{
                ml: 1,
                fontSize: "13px",
                fontWeight: 500,
                color: "#1976D2",
              }}
            >
              Edit
            </Typography>
          </Box>
        </Tooltip>
      </Box>
      )
      }
    </Box>
  );
};

export const getColumns = (
  setSelectedReason,
  setOpenStatusChangeModal,
  handleEdit
) => [
  {
    field: "sn",
    headerName: "SN",
    width: 80,
    sortable: false,
    filterable: false,
    renderCell: (params) => {
      const visibleSortedRows = params.api.getSortedRowIds?.();
      const index = visibleSortedRows?.indexOf(params.id);
      return index !== undefined ? index + 1 : "";
    },
  },
  {
    field: "reason_name",
    headerName: "Name",
    width: 300,
  },
  {
    field: "status",
    headerName: "Status",
    width: 350,
    headerAlign: "center",
    align: "center",
    renderCell: (params) => (
      <StatusCell
        params={params}
        setSelectedRow={setSelectedReason}
        setOpenStatusChangeModal={setOpenStatusChangeModal}
      />
    ),
  },
  {
    field: "action",
    headerName: "Action",
    width: 200,
    sortable: false,
    renderCell: (params) => handleActions(params, handleEdit),
  },
];
